export default __webpack_public_path__ + "static/media/fire4.73673880.png";